const lazyImages = [].slice.call(document.querySelectorAll("._arkn-lazy"));

if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (
        entries,
        _observer
    ) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                let lazyImage = entry.target;
                if (lazyImage.nodeName === "PICTURE") {
                    const img = lazyImage.querySelector("img");
                    const sources = lazyImage.querySelectorAll("source");

                    img.src = img.dataset.src;
                    sources.forEach(source => {
                        source.srcset = source.dataset.src
                    })

                    lazyImage.classList.remove("_arkn-lazy");
                    lazyImageObserver.unobserve(lazyImage);
                } else if (lazyImage.nodeName === "IMG") {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("_arkn-lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            }
        });
    });

    lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
    });
}
